import state404EnvelopePng from '../../../../resources/assets/state-404-envelope.png';
import stateAddVenuePng from '../../../../resources/assets/state-add-venue.png';
import stateConnectionResolvedPng from '../../../../resources/assets/state-conversation-resolved.png';
import stateEmptyBoxPng from '../../../../resources/assets/state-empty-box.png';
import stateEmptyMailboxPng from '../../../../resources/assets/state-empty-mailbox.png';
import stateEmptyShoppingBagsPng from '../../../../resources/assets/state-empty-shopping-bags.png';
import stateEmptyWalletPng from '../../../../resources/assets/state-empty-wallet.png';
import stateErrorBrokenConnectionPng from '../../../../resources/assets/state-error-broken-connection.png';
import stateLocationNotFoundPng from '../../../../resources/assets/state-location-not-found.png';
import stateNoResultsSearchPng from '../../../../resources/assets/state-no-results-search.png';
import stateStyleUndecidedPng from '../../../../resources/assets/state-style-undecided.png';
import stateUnknownDirectionPng from '../../../../resources/assets/state-unknown-direction.png';

export type StateIllustrationKey =
  | '404'
  | 'addVenue'
  | 'connectionResolved'
  | 'emptyBox'
  | 'emptyMailbox'
  | 'emptyShoppingBags'
  | 'emptyWallet'
  | 'errorBrokenConnection'
  | 'locationNotFound'
  | 'noResultsSearch'
  | 'styleUndecided'
  | 'unknownDirection';

function resolveAssetUrl(asset: string | { src: string }) {
  return typeof asset === 'string' ? asset : asset.src;
}

export const stateIllustrations: Record<StateIllustrationKey, string> = {
  '404': resolveAssetUrl(state404EnvelopePng),
  addVenue: resolveAssetUrl(stateAddVenuePng),
  connectionResolved: resolveAssetUrl(stateConnectionResolvedPng),
  emptyBox: resolveAssetUrl(stateEmptyBoxPng),
  emptyMailbox: resolveAssetUrl(stateEmptyMailboxPng),
  emptyShoppingBags: resolveAssetUrl(stateEmptyShoppingBagsPng),
  emptyWallet: resolveAssetUrl(stateEmptyWalletPng),
  errorBrokenConnection: resolveAssetUrl(stateErrorBrokenConnectionPng),
  locationNotFound: resolveAssetUrl(stateLocationNotFoundPng),
  noResultsSearch: resolveAssetUrl(stateNoResultsSearchPng),
  styleUndecided: resolveAssetUrl(stateStyleUndecidedPng),
  unknownDirection: resolveAssetUrl(stateUnknownDirectionPng),
};
